import { appLogger } from '../../../utils/appLogger';

interface LogEvent {
  level: 'info' | 'warn' | 'error';
  action: string;
  details?: any;
}

export const logEvent = (event: LogEvent) => {
  appLogger.info(`[${event.level.toUpperCase()}] ${event.action}:`, event.details);
};
